import { ActionContext } from 'vuex';

import { EndpointEnum } from '@empathybroker/tsclient-play/dist/enums/endpoint.enum';

import { CrudDataTypeEnum, DomainEnum } from '../../../enums';

import { ActionClass, ContextState, CrudState } from '../../../models';

import { AUTH_CONSTS } from '../../../store/auth/auth.consts';
import { CONTEXT_CONSTS } from '../../../store/context/context.consts';
import { FetchDataAction } from '../../../store/crud/actions/fetch-data.action';
import { CRUD_CONSTS } from '../../../store/crud/crud.consts';

export class ReadAction implements ActionClass {

  public static execute({ commit, state, rootGetters }: ActionContext<CrudState, any>,
    payload: { dataType: CrudDataTypeEnum, ids: string[] }): Promise<any[]> {
    commit(CRUD_CONSTS.mutations.setState, {
      dataType: payload.dataType
    });

    const context: ContextState = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const serviceClient = FetchDataAction.getServiceClient(payload.dataType, context);
    const authToken: string = rootGetters[`${ AUTH_CONSTS.moduleName }/${ AUTH_CONSTS.getters.token }`];
    return new Promise((resolve, reject) => {
      Promise.all(ReadAction.getServiceRequests(payload.dataType, serviceClient, authToken, payload.ids, context.domain))
        .then((responses: any[]) => {
          const data = responses.map((response: any) => response.data);
          commit(CRUD_CONSTS.mutations.setState, {
            data: data,
            pagination: {
              ...state.pagination,
              totalItems: data.length
            }
          });
          resolve(responses);
        })
        .catch(reject);
    });
  }

  private static getServiceRequests(dataType: CrudDataTypeEnum, serviceClient: any, authToken: string, ids: string[],
    domain?: DomainEnum): Promise<any>[] {
    if (dataType === CrudDataTypeEnum.USERS) {
      return ids.map((id: string) => serviceClient.read(authToken, id));
    }
    const endpoint: EndpointEnum = FetchDataAction.getPlayEndpointFromDomain(domain);
    return ids.map((id: string) => serviceClient.read(authToken, dataType, id, endpoint));
  }

}
